import { Translation } from "react-i18next";
import { Tool } from "../../models/Tool";
import { Button, makeStyles } from "@fluentui/react-components";
import { SkanskaColorTokens } from "../../style/colors";
import ToolActivitiesDialog from "./ToolActivitiesDialog";
import { useState } from "react";

const useStyles = makeStyles({
  seeActivitiesButton: {
    border: "none",
    padding: 0,
    minWidth: "auto",
    background: "none",
    textAlign: "left",
    width: "100%",
    display: "flex",
    justifyContent: "start",
    color: SkanskaColorTokens.color_action_blue,
    fontWeight: "400",
  },
});

interface ToolActivitiesDataGridCellProps {
  tool: Tool;
}

const ToolActivitiesDataGridCell = (props: ToolActivitiesDataGridCellProps) => {
  const { tool } = props;
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  return (
    <>
      <Translation>
        {(t) => (
          <Button
            className={classes.seeActivitiesButton}
            onClick={() => setOpen(true)}
          >
            {tool.activities?.length === 0 || tool.activities == undefined
              ? "-"
              : `${
                  tool.activities?.length === 1
                    ? t("showActivity")
                    : t("showActivities")
                } (${tool.activities?.length})`}
          </Button>
        )}
      </Translation>
      <ToolActivitiesDialog
        open={open}
        onClose={() => setOpen(false)}
        activities={tool.activities ? tool.activities : []}
        toolTitle={tool.title}
      />
    </>
  );
};

export default ToolActivitiesDataGridCell;
